(function () {
  var ITI_UTILS = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.js';

  function pairedFull(input) {
    var group = input.closest('[data-phone-group]');
    return group ? group.querySelector('[data-phone-full]') : null;
  }

  function toDoubleZero(n) {
    if (!n) return '';
    return n.charAt(0) === '+' ? '00' + n.substring(1) : n;
  }

  function toPlus(n) {
    n = ('' + (n || '')).trim();
    if (!n) return '';
    if (n.indexOf('00') === 0) return '+' + n.substring(2);
    if (n.charAt(0) === '+') return n;
    return '+' + n;
  }

  function compose(input) {
    var iti = input.__iti;
    var full = pairedFull(input);
    if (!iti || !full) return;
    var num = input.value.trim() ? toDoubleZero(iti.getNumber()) : '';
    if (full.value !== num) {
      full.value = num;
      full.dispatchEvent(new Event('input', { bubbles: true }));
      full.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function prefill(input) {
    var iti = input.__iti;
    var full = pairedFull(input);
    if (!iti || !full) return;
    var stored = (full.value || '').trim();
    if (stored && !input.value.trim()) {
      iti.promise.then(function () { iti.setNumber(toPlus(stored)); });
    }
  }

  var IP_KEY = 'shk-ip-country';
  var ipPromise = null;

  function ipCountry() {
    if (ipPromise) return ipPromise;
    var cached = '';
    try { cached = sessionStorage.getItem(IP_KEY) || ''; } catch (e) {}
    if (cached) {
      window.detectedCountryCode = window.detectedCountryCode || cached;
      ipPromise = Promise.resolve(cached);
      return ipPromise;
    }
    ipPromise = fetch('https://ipapi.co/json/')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (d) {
        var code = d && /^[A-Z]{2}$/.test(d.country_code || '') ? d.country_code : '';
        if (code) {
          window.detectedCountryCode = window.detectedCountryCode || code;
          try { sessionStorage.setItem(IP_KEY, code); } catch (e) {}
        }
        return code;
      })
      .catch(function () { return ''; });
    return ipPromise;
  }

  function addressScope(el) {
    return el.closest('[data-address-row]') || el.closest('form');
  }

  function scopedField(el, selector) {
    var scope = addressScope(el);
    return scope ? scope.querySelector(selector) : null;
  }

  function hasOption(select, code) {
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === code) return true;
    }
    return false;
  }

  function countryIsOpen(select) {
    if (!select || select.value || select.offsetParent === null) return false;
    if (select.classList.contains('account-locked') || select.options.length < 2) return false;
    var text = scopedField(select, '[data-address-country-text]');
    return !(text && text.value.trim());
  }

  function suggestCountry(select, code) {
    if (!code || !countryIsOpen(select) || !hasOption(select, code)) return;
    select.value = code;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyCountryDefaults() {
    var list = document.querySelectorAll('select[data-address-country]');
    var open = [];
    for (var i = 0; i < list.length; i++) {
      if (countryIsOpen(list[i])) open.push(list[i]);
    }
    if (!open.length) return;
    ipCountry().then(function (code) {
      open.forEach(function (select) { suggestCountry(select, code); });
    });
  }

  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select || !select.matches || !select.matches('select[data-address-country]') || !select.value) return;
    var phone = scopedField(select, 'input.intl-phone');
    if (phone && phone.__iti && !phone.value.trim()) phone.__iti.setCountry(select.value.toLowerCase());
  });

  function initOne(input, country) {
    if (input.closest('.iti')) { prefill(input); return; }
    var iti = window.intlTelInput(input, {
      utilsScript: ITI_UTILS,
      preferredCountries: ['tr', 'us', 'gb'],
      separateDialCode: true,
      initialCountry: country,
      formatOnDisplay: true,
      autoPlaceholder: 'aggressive'
    });
    input.__iti = iti;
    prefill(input);
    input.addEventListener('input', function () { compose(input); });
    input.addEventListener('countrychange', function () {
      compose(input);
      if (!input.__itiReady) return;
      var data = iti.getSelectedCountryData();
      var select = scopedField(input, 'select[data-address-country]');
      if (select && data && data.iso2) suggestCountry(select, data.iso2.toUpperCase());
    });
    setTimeout(function () { input.__itiReady = true; }, 0);
    input.addEventListener('blur', function () {
      compose(input);
      if (!input.value.trim()) {
        input.classList.remove('is-valid', 'is-invalid');
      } else if (iti.isValidNumber && iti.isValidNumber()) {
        input.classList.remove('is-invalid');
        input.classList.add('is-valid');
      } else {
        input.classList.remove('is-valid');
        input.classList.add('is-invalid');
      }
    });
  }

  function initIntlPhones() {
    if (!window.intlTelInput) return;
    var list = document.querySelectorAll('input.intl-phone');
    if (!list.length) return;
    var country = window.detectedCountryCode || 'tr';
    for (var i = 0; i < list.length; i++) {
      var inp = list[i];
      if (inp.closest('.iti')) { prefill(inp); }
      else if (inp.offsetParent !== null) { initOne(inp, country); }
    }
  }

  function refresh() {
    initIntlPhones();
    applyCountryDefaults();
  }

  function start() {
    refresh();
    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (window.__phoneInitTimer) return;
        window.__phoneInitTimer = setTimeout(function () {
          window.__phoneInitTimer = null;
          refresh();
        }, 150);
      });
      obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
    document.addEventListener('shown.bs.modal', function () { setTimeout(refresh, 100); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
})();
